// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ee84cc1","239":"e265ba93","453":"b5dab18f","455":"ded33fac"}[chunkId] + ".chunk.js";
};